import { dataByTypename } from '../../utils/apollo-helpers'
import {
  CUSTOMER_SERVER,
  LOGIN_SERVER,
  MFA_LOGIN_SERVER
} from './authentication.graphql'
import { storage, setTokens, deleteTokens, cleanUpCartData } from './authentication-helpers'
import { ooV2Auth } from './oov2-auth'

export const handleAuthResponse = (response) => {
  const {
    AuthenticationResponse: data,
    MfaChallengeGeneratedResponse: mfaData,
    LoginError: error
  } = dataByTypename(response)

  if (error) {
    deleteTokens()
    return error
  }

  if (mfaData) return mfaData

  setTokens(data)
  return data
}

export const authenticationResolvers = {
  Query: {
    customer: async (obj, args, { client }) => {
      let token = storage.get('accessToken')
      if (!token) {
        // Fall back to OO V2 if possible
        const ooV2Tokens = await ooV2Auth.getTokens()
        if (ooV2Tokens) {
          setTokens(ooV2Tokens)
          token = storage.get('accessToken')
        }
      }
      if (token) {
        try {
          const result = await client.query({
            query: CUSTOMER_SERVER,
            fetchPolicy: 'network-only'
          })
          return result.data.customer
        } catch (err) {
          throw new Error('Authentication Error')
        }
      }
      return undefined
    }
  },
  Mutation: {
    login: async (_, { input: { email, password } }, { client }) => {
      try {
        const resp = await client.mutate({
          mutation: LOGIN_SERVER,
          variables: {
            input: { email, password }
          }
        })

        return handleAuthResponse(resp.data.login)
      } catch ({ message }) {
        deleteTokens()
        return { message, __typename: 'LoginError' }
      }
    },
    mfaLogin: async (_, { input: { code, challengeToken, email } }, { client }) => {
      try {
        const resp = await client.mutate({
          mutation: MFA_LOGIN_SERVER,
          variables: {
            input: { code, challengeToken, email }
          }
        })

        return handleAuthResponse(resp.data.mfaLogin)
      } catch ({ message }) {
        deleteTokens()
        return { message, __typename: 'LoginError' }
      }
    },
    logout: async (_obj, { input: { cart } }, { client }) => {
      await cleanUpCartData(client, { cart })
      deleteTokens()
      client.resetStore()
      return {
        message: 'success!',
        __typename: 'LogoutResponse'
      }
    },
    authenticate: (
      _,
      { input: { accessToken, refreshToken, customerGuid } }
    ) => {
      setTokens({ accessToken, refreshToken })
      return {
        accessToken,
        refreshToken,
        customerGuid,
        __typename: 'AuthenticationResponse'
      }
    }
  }
}
